import { Component, CUSTOM_ELEMENTS_SCHEMA, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ShRadioCardComponent, ShRadioCardItemComponent } from '@shs-digi-care-monorepo/frontend-lib';
import { createDealTypeFormGroup, DealType, DealTypeFormGroup } from '../../models/deal-type.model';

@Component({
    selector: 'app-deal-type',
    templateUrl: './deal-type.component.html',
    imports: [TranslateModule, ReactiveFormsModule, ShRadioCardComponent, ShRadioCardItemComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DealTypeForm {
    public continue = output<void>();

    public formGroup: FormGroup<DealTypeFormGroup> = createDealTypeFormGroup();
    protected DealType = DealType;

    constructor() {
        this.formGroup.controls.dealType.valueChanges.subscribe(() => {
            this.continue.emit();
        });
    }
}
